import "./style.scss"
import Splide from "@splidejs/splide"
import "@splidejs/splide/dist/css/splide.min.css"
import AOS from "aos"
import "aos/dist/aos.css"
import tablesort from "tablesort"

import { initMeinAbax } from "./js/mein-abax"

initMeinAbax()

if (
  document.querySelector("form.job-search") &&
  document.querySelector(".content-modul-jobsuche") &&
  window.location.search !== ""
) {
  const headerHeight = document.querySelector(".fixed-nav-bar").offsetHeight
  window.scroll({
    top:
      document.querySelector(".content-modul-jobsuche").offsetTop -
      headerHeight / 2,
    behavior: "smooth",
  })
}

if (document.querySelector("#reviewsplide") !== null) {
  var reviewsplide = new Splide("#reviewsplide", {
    type: "slide",
    perPage: 1,
    perMove: 1,
    arrowPath: " ",
    autoplay: false,
    pagination: true,
    interval: 3000,
    speed: 1000,
  })
  reviewsplide.on("pagination:mounted", (data) => {
    const pageCount = data.items.length
    data.items.forEach((item) => {
      const actualPage = item.page + 1
      item.button.textContent = actualPage + " / " + pageCount
    })
  })
  reviewsplide.mount()
}

if (document.querySelector("#highlightsplide") !== null) {
  var highlightsplide = new Splide("#highlightsplide", {
    type: "slide",
    perPage: 2,
    perMove: 2,
    arrowPath: " ",
    gap: "60px",
    autoplay: false,
    pagination: true,
    interval: 3000,
    speed: 1000,
    breakpoints: {
      1024: {
        perPage: 1,
        perMove: 1,
      },
    },
  })
  highlightsplide.on("pagination:mounted", (data) => {
    const pageCount = data.items.length
    data.items.forEach((item) => {
      const actualPage = item.page + 1
      item.button.textContent = actualPage + " / " + pageCount
    })
  })
  highlightsplide.mount()
}

if (document.querySelector("#teamsplide") !== null) {
  var teamsplide = new Splide("#teamsplide", {
    type: "slide",
    perPage: 2,
    perMove: 2,
    arrowPath: " ",
    gap: "60px",
    autoplay: false,
    pagination: true,
    interval: 3000,
    speed: 1000,
    breakpoints: {
      1024: {
        perPage: 1,
        perMove: 1,
      },
    },
  })
  teamsplide.on("pagination:mounted", (data) => {
    const pageCount = data.items.length
    data.items.forEach((item) => {
      const actualPage = item.page + 1
      item.button.textContent = actualPage + " / " + pageCount
    })
  })
  teamsplide.mount()
}

if (document.querySelector("#videosplide") !== null) {
  var videosplide = new Splide("#videosplide", {
    type: "slide",
    perPage: 2,
    perMove: 1,
    arrowPath: " ",
    gap: "60px",
    autoplay: false,
    pagination: true,
    interval: 3000,
    speed: 1000,
    breakpoints: {
      1024: {
        perPage: 1,
        perMove: 1,
      },
    },
  })
  videosplide.on("pagination:mounted", (data) => {
    const pageCount = data.items.length
    data.items.forEach((item) => {
      const actualPage = item.page + 1
      item.button.textContent = actualPage + " / " + pageCount
    })
  })
  videosplide.mount()

  var videoButtons = document.querySelectorAll(".video-button")

  videoButtons.forEach((videoButton) => {
    videoButton.addEventListener("click", (event) => {
      const video = document.querySelector(".video-lightbox .gr .gc-1-1 video")
      const videoLightbox = document.querySelector(".video-lightbox")
      video.innerHTML = ""
      const videoSrc = document.createElement("source")
      videoSrc.setAttribute("src", event.target.getAttribute("data-video-url"))
      videoSrc.setAttribute("type", "video/mp4")
      video.appendChild(videoSrc)
      video.load()
      videoLightbox.classList.toggle("show-lightbox")

      if (video) {
        if (video.paused) video.play()
        else video.pause()
      }
    })
  })
  const lightboxCloseButtons = document.querySelectorAll(".close-lightbox")
  lightboxCloseButtons.forEach((button) => {
    button.addEventListener("click", () => {
      button.parentElement.parentElement.parentElement.classList.remove(
        "show-lightbox"
      )
      if (button.nextElementSibling) {
        if (button.nextElementSibling.paused) button.nextElementSibling.play()
        else button.nextElementSibling.pause()
      }
    })
  })
  const lightboxClose = document.querySelectorAll(".video-lightbox")
  lightboxClose.forEach((lightbox) => {
    lightbox.addEventListener("click", () => {
      lightbox.classList.remove("show-lightbox")
      lightbox.preventDefault()
      lightbox.stopPropagation()
    })
  })
}

AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
  initClassName: "aos-init", // class applied after initialization
  animatedClassName: "aos-animate", // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 200, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 1000, // values from 0 to 3000, with step 50ms
  easing: "ease", // default easing for AOS animations
  once: true, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: "top-buttom", // defines which position of the element regarding to window should trigger the animation
})

document.addEventListener("DOMContentLoaded", () => {
  const menuToggle = document.querySelector("button.main-menu-toggle")
  const mobileMenu = document.querySelector(".mobile-menu-container")
  const mobileMenuSurface = document.querySelector(".mobile-menu-container")
  if (menuToggle !== undefined && mobileMenu !== undefined) {
    menuToggle.addEventListener("click", () => {
      mobileMenu.classList.toggle("open")
    })
    mobileMenuSurface.addEventListener("click", () => {
      mobileMenu.classList.remove("open")
    })
  }

  // Smooth scroll on page
  if (
    window.location.hash !== "" &&
    document.querySelector(window.location.hash)
  ) {
    window.scrollTo(0, 0) // Checkmate browser behavior
    const headerHeight = document.querySelector(".fixed-nav-bar").offsetHeight
    window.scroll({
      top:
        document.querySelector(window.location.hash).offsetTop - headerHeight,
      behavior: "smooth",
    })
  }
})

// Mobile Menu
var mobileMenuItems = document.querySelectorAll(
  ".mobile-menu li.menu-item-has-children"
)
mobileMenuItems.forEach((item) => {
  item
    .querySelector(".mobile-menu-arrow")
    .addEventListener("click", (event) => {
      event.stopPropagation()
      event.preventDefault()
      const submenu = item.querySelector(".sub-menu")
      submenu.classList.toggle("visible")
    })
})

var header = document.getElementById("fixed-header")
var headerfixedbar = document.getElementById("fixed-header-bar")
var sticky = headerfixedbar.offsetTop

function stickyheaderFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("fixed")
  } else {
    header.classList.remove("fixed")
  }
}

let lastKnownScrollPosition = 0
let ticking = false

function toggleToTopButton(scrollPos) {
  const toTopButton = document.querySelector(".to-top-button")
  if (
    scrollPos > 0 &&
    scrollPos + window.innerHeight < document.body.offsetHeight
  ) {
    toTopButton.classList.add("visible")
  } else {
    toTopButton.classList.remove("visible")
  }
}

document.addEventListener("scroll", (e) => {
  lastKnownScrollPosition = window.scrollY

  // Throttle scroll events for performance reasons
  if (!ticking) {
    window.requestAnimationFrame(() => {
      stickyheaderFunction()
      toggleToTopButton(lastKnownScrollPosition)
      ticking = false
    })

    ticking = true
  }
})

// Smooth Scrolling
const anchorLinks = document.querySelectorAll('a[href^="#"]')
anchorLinks.forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault()
    const headerHeight = document.querySelector(".fixed-nav-bar").offsetHeight
    const href = link.getAttribute("href")
    const scrollingTo = document.querySelector(href)
    if (scrollingTo) {
      const offsetTop = scrollingTo.offsetTop
      window.scroll({
        top: offsetTop - headerHeight,
        behavior: "smooth",
      })
    }
  })
})

// Check if sub menus exit viewport
const isFullyInViewport = (el) => {
  var rect = el.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

let observer = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (isFullyInViewport(entry.target) === false) {
      entry.target.style.right = 0
      observer.unobserve(entry.target)
    }
  })
})

document.querySelectorAll(".desktop-menu .sub-menu").forEach((submenu) => {
  observer.observe(submenu)
})


// Jobs
document.querySelectorAll(".job-toggle").forEach((toggle) => {
  toggle.addEventListener("click", (event) => {
    toggle.classList.toggle("open")
  })
})

const applicationModalButton = document.querySelector(
  ".job-application-form-toggle"
)
if (applicationModalButton) {
  applicationModalButton.addEventListener("click", () => {
    const applicationModal = document.querySelector(
      ".job-application-form-modal-overlay"
    )
    if (applicationModal) {
      applicationModal.classList.add("open")
    }

    applicationModal.addEventListener("click", (event) => {
      if (event.target === applicationModal) {
        applicationModal.classList.remove("open")
      }
    })
  })
}

/* Funnel-Funktionen */

function getCurrentFunnelFieldset() {
  const fieldsets = document.querySelectorAll(
    ".module-form-funnel form fieldset"
  )
  let currentFieldsetIndex = null
  fieldsets.forEach((fieldset, index) => {
    if (fieldset.classList.contains("current")) {
      currentFieldsetIndex = index
    }
  })
  return currentFieldsetIndex
}

function setCurrentFunnelFieldset(newIndex) {
  const fieldsets = document.querySelectorAll(
    ".module-form-funnel form fieldset"
  )
  let currentFieldsetIndex = null
  fieldsets.forEach((fieldset, index) => {
    fieldset.classList.remove("current")
    if (index === newIndex) {
      fieldset.classList.add("current")
    }
  })
  return currentFieldsetIndex
}

document.querySelectorAll("div.funnel-next-page").forEach((nextButton) => {
  nextButton.addEventListener("click", (event) => {
    setCurrentFunnelFieldset(getCurrentFunnelFieldset() + 1)
  })
})

document.querySelectorAll("div.funnel-previous-page").forEach((nextButton) => {
  nextButton.addEventListener("click", (event) => {
    setCurrentFunnelFieldset(getCurrentFunnelFieldset() - 1)
  })
})

document
  .querySelectorAll(".module-form-funnel input[type=radio]")
  .forEach((radioButton) => {
    radioButton.addEventListener("click", () => {
      setCurrentFunnelFieldset(getCurrentFunnelFieldset() + 1)
    })
  })

document.addEventListener("wpcf7mailsent", (event) => {
  const successMessage = event.target.querySelector("div.success")
  const fieldsets = event.target.querySelectorAll("fieldset")
  if (successMessage) {
    fieldsets.forEach((fieldset) => fieldset.classList.remove("current"))
    successMessage.classList.add("current")
  }
})

/* Kontaktleiste */
const contactBarToggle = document.querySelector(".abax-sidebar-toggle")
const contactBar = document.querySelector(".abax-sidebar")
if (contactBarToggle && contactBar) {
  contactBarToggle.addEventListener("click", () => {
    if (contactBar) {
      contactBar.classList.add("open")
    }
  })

  document.addEventListener("click", function (event) {
    if (
      !contactBar.contains(event.target) &&
      !contactBarToggle.contains(event.target) &&
      (event.target.closest(".open-contact-widget") == null ||
        !event.target.closest(".open-contact-widget").contains(event.target)) &&
      contactBar.classList.contains("open")
    ) {
      contactBar.classList.remove("open")
    }
  })
}

document.querySelectorAll(".open-contact-widget").forEach((button) => {
  button.addEventListener("click", (event) => {
    event.preventDefault()
    contactBar.classList.add("open")
  })
})

document
  .querySelectorAll(".abax-quick-form fieldset input")
  .forEach((input) => {
    input.addEventListener("click", (event) => {
      const parentFieldset = event.target.closest("fieldset")
      if (parentFieldset && parentFieldset.nextElementSibling) {
        parentFieldset.nextElementSibling.classList.add("current")
      }
    })
  })

/* Stellenangebote */

const jobPostingList = document.querySelector(
  ".module-job-list .job-postings table"
)
if (jobPostingList) {
  tablesort(jobPostingList)
}

const jobLoadingButton = document.querySelector(
  ".load-more-container button.load-jobs"
)
if (jobLoadingButton) {
  jobLoadingButton.addEventListener("click", (event) => {
    event.target.disabled = true
    fetch("/wp-json/abax/v1/load-more-jobs", {
      method: "POST",
      body: JSON.stringify({
        query: window.query,
        page: event.target.getAttribute("data-page"),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.results) {
          const jobTable = document.querySelector(
            ".module-job-list .job-postings table"
          )
          if (jobTable) {
            jobTable.querySelector("tbody").innerHTML += data.results
          }
          if (data.last_page) {
            event.target.style.display = "none"
          } else {
            event.target.setAttribute(
              "data-page",
              parseInt(event.target.getAttribute("data-page")) + 1
            )
          }
        }
      })
      .finally(() => {
        event.target.disabled = false
      })
  })
}

/* Beiträge */
const postLoadingButton = document.querySelector(
  ".load-more-container button.load-posts"
)
if (postLoadingButton) {
  postLoadingButton.addEventListener("click", (event) => {
    event.target.disabled = true
    fetch("/wp-json/abax/v1/load-more-posts", {
      method: "POST",
      body: JSON.stringify({
        query: window.query,
        page: event.target.getAttribute("data-page"),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.results) {
          const postList = document.querySelector(
            ".category-content .post-list"
          )
          if (postList) {
            postList.innerHTML += data.results
          }
          if (data.last_page) {
            event.target.style.display = "none"
          } else {
            event.target.setAttribute(
              "data-page",
              parseInt(event.target.getAttribute("data-page")) + 1
            )
          }
        }
      })
      .finally(() => {
        event.target.disabled = false
      })
  })
}

const highlightFilters = document.querySelectorAll(
  ".page-template-highlights .highlight-filters select"
)
highlightFilters.forEach((filter) => {
  filter.addEventListener("change", (event) => {
    event.target.closest("form").submit()
  })
})

/* Animation Video */
document
  .querySelectorAll(".content-modul-videoheaderhome")
  .forEach((header) => {
    const video = header.querySelector("video")
    if (video) {
      video.addEventListener("canplay", () => {
        document.querySelectorAll(".delayed-animation").forEach((element) => {
          const delay = element.getAttribute("data-delay")
          setTimeout(() => {
            element.classList.add("animate")
          }, delay)
        })
      })
    }
  })

window.addEventListener("load", () => {
  AOS.refresh()
})

/* Online-Bewerbung */
const jobApplicationForm = document.querySelector(
  ".job-application-form-modal form.application-form"
)
if (jobApplicationForm) {
  const messageBox = document.querySelector(".form-status-message")
  jobApplicationForm.addEventListener("submit", async (event) => {
    const submitButton = jobApplicationForm.querySelector("input[type=submit]")
    submitButton.disabled = true
    event.preventDefault()
    const response = await fetch("https://jobs.compana.net/x/webapi/?json=1", {
      method: "POST",
      body: new FormData(jobApplicationForm),
    })
    if (response.ok) {
      jobApplicationForm.reset()
      messageBox.classList.add("success")
      messageBox.textContent =
        "Vielen Dank! Wir haben Ihre Bewerbung erhalten und melden uns schnellstmöglich bei Ihnen."
    } else {
      messageBox.classList.add("error")
      messageBox.textContent =
        "Ein Fehler ist aufgetreten. Bitte prüfen Sie ggf. Ihre Angaben und versuchen Sie es erneut."
    }
    submitButton.disabled = false
  })
}

const generatePassword = (
  length = 20,
  characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$'
) =>
  Array.from(crypto.getRandomValues(new Uint32Array(length)))
    .map((x) => characters[x % characters.length])
    .join('')

if(document.querySelector('.ur-frontend-form')) {
  const currentPassword = generatePassword()
  document.querySelectorAll('.ur-frontend-form .input-password').forEach(element => {
    element.value = currentPassword
  });
}


